export default __webpack_public_path__ + "static/media/Workshop_page2.8b41ed08.jpg";